var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3509_29665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.21021 2.06671H4.84078C5.4827 2.06671 6.09834 2.32172 6.55225 2.77562C7.00616 3.22953 7.26116 3.84517 7.26116 4.48709V12.9584C7.26116 12.477 7.06991 12.0153 6.72948 11.6748C6.38904 11.3344 5.92732 11.1431 5.44587 11.1431H1.21021V2.06671Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3122 2.06671H9.68161C9.03969 2.06671 8.42405 2.32172 7.97014 2.77562C7.51623 3.22953 7.26123 3.84517 7.26123 4.48709V12.9584C7.26123 12.477 7.45248 12.0153 7.79292 11.6748C8.13335 11.3344 8.59507 11.1431 9.07652 11.1431H13.3122V2.06671Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3509_29665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5223,
    height: 14.5223,
    fill: "white",
    transform: "translate(0 0.251404)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.1b90696d722433a461f8d694aa2d1d3c.svg";
export { ForwardRef as ReactComponent };